import React, { useContext } from 'react'
import styled from 'styled-components'
import { useAlert } from 'hooks'
import { Button } from 'ui/acro'
import { axios } from 'api'
import { camelToSnake } from 'utils'
import { dispatchProgramAction } from './ProgramButtonActions'
import { ProgramContext } from 'components_v2/page_context'

const Retake = styled(Button)`
  color: #fff;
  width: 343px;
  max-width: 100%;
  background: #000;
  font-family: 'Proxima-Nova';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  padding: 12px 32px;
  margin-top: 24px;
  border-radius: 0;
  @media (max-width: 600px) {
    background: none;
    color: #000;
    padding: 0;
    border: none;
    border-radius: 0;
    text-transform: capitalize;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.308px;
    text-decoration-line: underline;
    min-height: 0;
    min-width: 0;
    width: 105px;
  }
`

const RetakeProgram = ({ id }) => {
  const setAlert = useAlert()
  const { setProgramStatus = () => {}, setCompletedCount = () => {} } =
    useContext(ProgramContext)
  const retakeProgram = async () => {
    try {
      const res = await axios.post(`programs/${id}/retake`)
      if (res?.data?.ga4Event) {
        window.dataLayer ||= []
        window.dataLayer.push(camelToSnake(res.data?.ga4Event))
      }
      if (res.status === 201) {
        setProgramStatus('in_progress')
        setCompletedCount(0)
        setAlert(
          {
            message: (
              <p>
                <b>Program restarted!</b>
                <br />
                Your previous completion history is saved on the Completed tab
                of My Practice.
              </p>
            )
          },
          { autoClose: 3000 }
        )
        dispatchProgramAction('retake')
      }
    } catch (e) {
      console.error(e)
    }
  }

  return <Retake onClick={retakeProgram}>Retake Program</Retake>
}

export default RetakeProgram
